import {ChangeDetectorRef, Component, ElementRef, HostListener, inject, OnInit, Renderer2, Signal, ViewChild} from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd, RouterLink} from '@angular/router';
import { filter } from 'rxjs/operators';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { environment } from 'src/environments/environment';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {MediaQueryService} from '../../../services/media-query/media-query.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {BehaviorSubject, map, Observable, tap} from 'rxjs';
import {faBars, faSearch} from '@fortawesome/free-solid-svg-icons';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {MatButtonModule} from '@angular/material/button';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {desktopMenuOptions, NavigationOption, ParamOptions} from '../lb-sidebar/lb-navgation.options';
import { CrumbtrailService, crumbtrailItem } from 'src/app/services/crumbtrail/crumbtrail.service';
import { SettingsService } from 'src/app/services/settings/settings.service'; // Import the SettingsService
import { FormsModule } from '@angular/forms'; // Import FormsModule
import { Subscription } from 'rxjs'; // Import Subscription
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service'; // Import the RxAuthService

@Component({
  selector: 'app-lb-header',
  standalone: true,
  imports: [    NgIf,
    NgClass,
    RouterLink,
    NgForOf,
    MatButtonModule,
    FontAwesomeModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule, // Add FormsModule here
  ],
  templateUrl: './lb-header.component.html',
  styleUrls: ['./lb-header.component.scss']
})
export class LbHeaderComponent implements OnInit  {
  @ViewChild('searchBar', { read: ElementRef, static: false }) searchBar:
    | ElementRef
    | undefined;
  isLoggedIn: boolean = false;
  isProduction: boolean = false;
  onLandingPage: boolean = false;
  onExplorePage: boolean = false;
  onProfilePage: boolean = false;
  //crumbtrailContent:BehaviorSubject<crumbtrailItem[]> = new BehaviorSubject<crumbtrailItem[]>([]);
  //test = this.crumbtrailService.crumbtrailContent
  crumbtrailContent = this.crumbtrailService.crumbtrailContent;
  showCrumbtrail: boolean = true;
  searchValue: string = ''; // Add a property for search value
  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  public isOpened: boolean = false;

  public isMobile: Signal<boolean> = toSignal(
    this.mediaQueryService.getDisplayType().pipe(
      map(({ isMobile }) => isMobile),
      tap((isMobile) => (this.isOpened = isMobile && this.isOpened)) // ensures that if you resize the window to desktop, the search bar will be closed
    ),
    { initialValue: window.innerWidth < 768 }
  );
  public hamburgerMenuIcon: IconProp = faBars as IconProp;
  public navlist: NavigationOption[] = desktopMenuOptions;
  public searchIcon: IconProp = faSearch as IconProp;

  public isSwitchOn: boolean = false; // Add property for switch state
  private editModeSubscription: Subscription; // Subscription to the edit mode observable

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.searchBar?.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.isOpened = false;
    }
  }

  constructor(
    public auth: RxAuthService, // Change this line to inject RxAuthService
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public specialRoutingService: SpecialRoutingService,
    private crumbtrailService: CrumbtrailService,
    private settingsService: SettingsService // Inject the SettingsService
  ) {
    // Initialize the switch state from the service
    this.editModeSubscription = this.settingsService.editMode$.subscribe(
      (state) => {
        this.isSwitchOn = state; // Update the switch state based on the service
      }
    );
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.updateActiveState();
        //this.updateCrumbtrail(event)
      });
  }

  ngOnInit(): void {
    this.isProduction = environment.production;
    this.updateActiveState(); // Check initial route
    this.updateCrumbtrail();

    // Subscribe to query parameters
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['search']) {
        this.searchValue = params['search'];
      }
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    this.editModeSubscription.unsubscribe();
  }

  handleSearch(searchValue: string) {
    //if (searchValue && searchValue.trim()) {
    const encodedSearchValue = encodeURIComponent(searchValue.trim());
    this.router.navigate(['/explore'], {
      queryParams: { search: encodedSearchValue },
    });
    //} else {
    //  console.log('No search value provided');
    //}
  }

  updateActiveState() {
    const currentRoute =
      this.activatedRoute.snapshot.firstChild?.routeConfig?.path || '';
    this.onLandingPage = currentRoute === 'landing';
    this.onExplorePage = currentRoute === 'explore';
    this.onProfilePage = currentRoute === 'profile';
  }

  crumbtrailRedirect(item: any, index: any) {
    if (index === 0) {
      if (item.text === 'Retailers') {
        location.href = `${environment.frontend_base}explore?search=&view=retailers`;
      } else if (item.text === 'Rankings') {
        location.href = `${environment.frontend_base}explore?search=&view=lists`;
      }
      //location.href = `${environment.frontend_base}landing`
    } else if (index >= this.crumbtrailContent()!.length - 1) {
      //do nothing
    } else {
      window.location.href = `${environment.frontend_base}profile?id=${item.rcl}`;
    }
  }

  public navigate(option: NavigationOption): void {
    if (option.externalUrl) {
      // Navigate to external URL
      window.location.href = option.externalUrl;
    } else if (option.route) {
      // Internal navigation
      const params = option.params ? this.serializeParams(option.params) : {};
      this.router.navigate([option.route], { queryParams: params });
    }
  }

  public serializeParams(params: ParamOptions): { [key: string]: any } {
    const paramObject: { [key: string]: any } = {};

    if (params.search !== undefined) paramObject['search'] = params.search;
    if (params.view !== undefined) paramObject['view'] = params.view;
    if (params.id !== undefined) paramObject['id'] = params.id;

    return paramObject;
  }

  handleMenuClick(item: NavigationOption): void {
    this.navigate(item);
  }

  toggleSearch() {
    this.isOpened = !this.isOpened;
  }

  updateCrumbtrail(event?: any) {
    if (event) {
      let page = event.url.split('?')[0];

      if (page === '/profile') {
        this.showCrumbtrail = true;
      } else {
        this.showCrumbtrail = false;
      }
    } else {
      if (this.crumbtrailContent() && this.crumbtrailContent()!.length > 0) {
        this.showCrumbtrail = true;
      }
    }
  }

  // Method to handle switch change
  onSwitchChange(event: boolean): void {
    this.isSwitchOn = event;
    this.settingsService.setEditMode(this.isSwitchOn); // Update the service
  }
}
